// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridTable_grid__txjRS","stickyTable":"GridTable_stickyTable__A2oAx"};